"use strict";
import { useAccount } from "hooks/useAccount";
import { CONNECTION_PROVIDER_IDS } from "uniswap/src/constants/web3";
export function useIsUniExtensionConnected() {
  const currentConnector = useAccount().connector;
  return currentConnector?.id === CONNECTION_PROVIDER_IDS.UNISWAP_EXTENSION_RDNS;
}
